import * as HTTP from "./base";

const validate = async (data) => {
  let res = await HTTP.postUnauthenticated("login", data);
  HTTP.setToken(res.token);

  localStorage.setItem(HTTP.COMMON_LOCAL_STORAGE_KEY, JSON.stringify(res));

  return res;
};

export { validate };
